import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import jalali from "react-date-object/calendars/jalali";
import persian_fa from "react-date-object/locales/persian_fa";

// Preserve the selected calendar day without a UTC/timezone conversion.
const exportDate = (value) => value ? new DateObject({
  date: value,
  format: "YYYY-MM-DD",
  calendar: gregorian,
  locale: gregorian_en,
}).convert(jalali, persian_fa) : null;

export default exportDate;
